'use es6';

import enviro from 'enviro';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { createClient } from 'usage-tracker-core';
import { debugKey } from 'usage-tracker-core/storageKeys';
import { getHstc } from './helpers/cookieHelper';
import { defaultLanguage } from './helpers/langHelper';
import sendBeacon from './helpers/sendBeacon';
import reportError from './helpers/reportError';
import * as tempStorage from './containers/tempStorage';
const hasBeaconSupport = navigator && typeof navigator.sendBeacon === 'function';
const origin = getFullUrl('api');
const path = '/usage-logging/v1/log/hublytics-multi/no-auth';

const reportNetworkError = err => reportError(err, {
  fingerprint: ['usage-tracker-js', 'network']
});

const getDebug = () => enviro.debug(debugKey);

const getTrackerHstc = () => {
  return new Promise(resolve => {
    /* eslint-disable */
    let interval;
    let timeout;
    interval = setInterval(() => {
      const hstc = getHstc();

      if (hstc) {
        clearTimeout(timeout);
        clearInterval(interval);
        resolve(hstc);
      }
    }, 100);
    timeout = setTimeout(() => {
      if (!getHstc()) {
        clearInterval(interval);

        if (enviro.debug(debugKey) && console && typeof console.warn === 'function') {
          console.warn('Could not get tracker hstc after 8 seconds');
        }

        resolve(null);
      }
    }, 8000);
  });
};

const PublicTrackingClient = createClient({
  clientName: 'public',
  getDebug,
  getEmail: () => null,
  getHubId: () => null,
  getHstc: getTrackerHstc,
  getLang: () => defaultLanguage,
  getTempStorage: tempStorage.get,
  setTempStorage: tempStorage.set,
  logError: err => {
    if (getDebug()) {
      console.error(err);
    }
  },
  reportError,
  send: ({
    events,
    query,
    isBeforeUnload
  }) => {
    const endpoint = `${origin}${path}?${query}`;
    const data = events;

    const sendXhr = () => {
      const promise = noAuthApiClient.post(endpoint, {
        data
      }).catch(reportNetworkError);

      if (promise && typeof promise.done === 'function') {
        promise.done();
      }
    };

    if (isBeforeUnload && hasBeaconSupport) {
      sendBeacon(endpoint, data, sendXhr);
    } else {
      sendXhr();
    }
  }
});
export default PublicTrackingClient;